import { useMemo } from "react";

import { useDeepResearchSocketContext } from "@/pages/Private/pages/ProfileTracker/providers/DeepResearchSocketContext";

import { DeepResearchStatus, getDeepResearchStatus } from "./getDeepResearchStatus";

import type { ListPerson } from "../../../../../schema/list";

/** Combines the stored research response with the lead's live run or failure (PREC-4052). */
export const useDeepResearchStatus = (row: ListPerson): DeepResearchStatus | null => {
	const { getRun, getFailure } = useDeepResearchSocketContext();

	return useMemo(() => {
		const prospectId = row.prospect?.id;
		const live = getRun(prospectId)?.phase ?? (getFailure(prospectId) ? "failed" : null);

		return getDeepResearchStatus(row, live);
	}, [row, getRun, getFailure]);
};
